import { render, staticRenderFns } from "./OrganismSidebarBuilding.vue?vue&type=template&id=cba9e44e&"
import script from "./OrganismSidebarBuilding.vue?vue&type=script&lang=js&"
export * from "./OrganismSidebarBuilding.vue?vue&type=script&lang=js&"
import style0 from "./OrganismSidebarBuilding.vue?vue&type=style&index=0&id=cba9e44e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesProjectBuildingMoleculeSidebarHeader: require('/app/components/molecules/project/building/MoleculeSidebarHeader.vue').default,MoleculesProjectBuildingMoleculeSidebarResults: require('/app/components/molecules/project/building/MoleculeSidebarResults.vue').default})
